import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import * as api from "../../api";
import {useFeedbackTools} from "../../components/FeedbackTools";


export const useImportTasksQuery = (importTasksFilter={}) => {
    return useQuery({
        queryKey: ['importTasks', importTasksFilter],
        queryFn: () => api.ImportTask.getImportTasks(importTasksFilter),
        keepPreviousData: true
    })
}

export const useImportTaskQuery = (importTaskId) => {
    return useQuery({
        queryKey: ['importTasks', importTaskId],
        queryFn: () => api.ImportTask.getImportTask(importTaskId),
        keepPreviousData: true
    })
}

export const useCreateImportTask = () => {
    const {t} = useTranslation(["importTasks"])
    const queryClient = useQueryClient();
    const {showSuccessNotification}  = useFeedbackTools();
    const navigate = useNavigate();

    const mutationFn = async (data) => {
        const {format, ...rest} = data;
        if (format === "MOD1-CSV") {
            return await api.ImportTask.createImportModel1Csv(rest);
        } else if (format === "MOD1-HUSKY-CSV") {
            return await api.ImportTask.createImportModel1HuskyCsv(rest);
        } else if (format === "MOD1-TXT") {
            return await api.ImportTask.createImportModel1Txt(rest);
        } else if (format === "MOD23-X23") {
            return await api.ImportTask.createImportModel23X23(rest);
        } else if (format === "MOD23-CAAMLv6") {
            return await api.ImportTask.createImportModel23Caamlv6(rest);
        } else {
            throw new Error(t('query.invalidFormat'));
        }
    }

    return useMutation({
        mutationFn: async (data) => await mutationFn(data),
        onSuccess: () => {
            queryClient.invalidateQueries(['importTasks']);
            showSuccessNotification(t('query.createSuccess'));
            navigate(`/importTasks`);
        }
    });
}

export const useTaskErrorsQuery = (importTaskId, taskErrorsFilter) => {
    return useQuery({
        queryKey: ['importTasks', importTaskId, 'errors', taskErrorsFilter],
        queryFn: () => api.ImportTask.getImportTaskErrors(importTaskId, taskErrorsFilter),
        keepPreviousData: true
    })
}